import request from "../../request.js"
import URL from "../../url/hot/index.js"
import CONFIG from "../../../utils/config.js"
class Hot{
    //获取用户列表
    static common(){
        // let bdzhUserId = Storage.getCookie({key:"login_user_id"})
        // if(Util.isNull(bdzhUserId))return
        // bdzhUserId = bdzhUserId.split('~')[1]
        let url = `${URL.COMMON}`
        return request.get({
            url,
        })
    }
}

export default Hot